import { CommonModule, isPlatformBrowser } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { DateUtils } from '../../../../../shared/helpers/dateUtils';
import { EYesNo } from '../../../../../shared/models/types.enum';

@Component({
  selector: 'section-n',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './section-n.component.html',
  styleUrl: './section-n.component.css'
})
export class SectionNComponent implements OnInit, AfterViewInit {

  @Input() fullTeamAssessmentData: any;
  @Output() onSaveSection16 = new EventEmitter<any>();

  @ViewChild('datepickerWhen') datepickerWhen!: ElementRef;
  yesNo = EYesNo;

  sectionNForm: FormGroup = new FormGroup({});
  constructor(
    private cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngOnInit() {
    this.initializeForm();
    this.initializeDatepicker();
    this.onChanges();
  }  
  
  private initializeForm(): void {
    // radio input for each question
    this.sectionNForm = new FormGroup({
      suicide_risk_assessment: new FormControl(String(this.fullTeamAssessmentData?.suicide_risk_assessment) || this.yesNo.No, Validators.required),
      suicide_risk_assessment_person: new FormControl({value: this.fullTeamAssessmentData?.suicide_risk_assessment_person || null, disabled: this.fullTeamAssessmentData?.suicide_risk_assessment === this.yesNo.No}),
      suicide_risk_assessment_date: new FormControl({value: null, disabled: this.fullTeamAssessmentData?.suicide_risk_assessment === this.yesNo.No}),
    })

    this.onChanges();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fullTeamAssessmentData'] && this.fullTeamAssessmentData) {
      this.initializeForm();
    }
  }

  onChanges(): void {
    this.sectionNForm.get('suicide_risk_assessment')!.valueChanges.subscribe(val => {
      if (val === this.yesNo.Yes) {
        this.sectionNForm.get('suicide_risk_assessment_person')?.enable();
        this.sectionNForm.get('suicide_risk_assessment_person')?.setValidators(Validators.required);
        this.sectionNForm.get('suicide_risk_assessment_date')?.enable();
        this.sectionNForm.get('suicide_risk_assessment_date')?.setValue(DateUtils.formatDateForBackend(DateUtils.getCurrentFormattedDate()));
        this.sectionNForm.get('suicide_risk_assessment_date')?.setValidators(Validators.required);
      } else {
        this.sectionNForm.get('suicide_risk_assessment_person')?.disable();
        this.sectionNForm.get('suicide_risk_assessment_person')?.clearValidators();
        this.sectionNForm.get('suicide_risk_assessment_person')?.setValue(null);

        this.sectionNForm.get('suicide_risk_assessment_date')?.disable();
        this.sectionNForm.get('suicide_risk_assessment_date')?.clearValidators();
        this.sectionNForm.get('suicide_risk_assessment_date')?.setValue(null);
      }
      this.cdr.detectChanges(); // Manually trigger change detection
      this.initializeDatepicker();
    });
  }

  async initializeDatepicker() {
    const { Datepicker } = await import('flowbite-datepicker');
    if (this.datepickerWhen?.nativeElement) {
      new Datepicker(this.datepickerWhen.nativeElement, {
        autohide: true,
        format: 'mm/dd/yyyy'
      });
      // set default value to display 
      if (this.fullTeamAssessmentData?.suicide_risk_assessment_date) {
        // if date_of_incident is available, set it to the datepicker
        this.datepickerWhen.nativeElement.value = DateUtils.formatDateForDisplay(this.fullTeamAssessmentData.suicide_risk_assessment_date);
      } else {
        // if date_of_incident is not available, set it to the current date
        this.datepickerWhen.nativeElement.value = DateUtils.getCurrentFormattedDate();
      }

      this.datepickerWhen.nativeElement.addEventListener('changeDate', (event: any) => {
        const formattedDate = DateUtils.formatDateForBackend(event.target.value);
        this.sectionNForm.get('suicide_risk_assessment_date')?.setValue(formattedDate);
      });
    }
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.initializeDatepicker();
    }
  }  
  
  saveSectionN(): void {
    if (this.sectionNForm.invalid) {
      return;
    } else {
      this.onSaveSection16.emit(this.sectionNForm.value)
    }
  }
  
}
